/*
	FILE SYSTEMS
*/
//------------------------------------------------------------
// IMPORT
//------------------------------------------------------------

import File from '../files/File.js';
import FileSystem from './FileSystem.js';

//------------------------------------------------------------
// SYSTEM FOLDERS
//------------------------------------------------------------

const ROOT = files => new File({
	name: '0.0.0.0',
	children: [...files]
});

const DESKTOP = files => new File({
	name: 'Desktop',
	icon: 'fa fa-window-maximize',
	children: [...files]
});

const MY_COMPUTER = files => new File({
	name: 'My Computer',
	icon: 'fa fa-laptop',
	component: '/Programs/FileSystem/FileSystem',
	initProp: { path: '/Desktop/My Computer' , iconView: true },
	children: [...files]
});

const DRIVE = files => new File({
	name: 'Drive',
	type: 'System Folder',
	icon: 'fa fa-hdd-o',
	children: [...files]
});

const HOME = files => new File({
	name: 'Home',
	type: 'System Folder',
	children: [...files]
});

const DOCUMENTS = files => new File({
	name: 'Documents',
	type: 'System Folder',
	children: [...files]
});

const PICTURES = files => new File({
	name: 'Pictures',
	type: 'System Folder',
	children: [...files]
});

const LOGS = files => new File({
	name: 'Logs',
	type: 'System Folder',
	children: [...files]
});

const PROGRAMS = files => new File({
	name: 'Programs',
	type: 'System Folder',
	children: [...files]
});

const ACCESSORIES = files => new File({
	name: 'Accessories',
	type: 'System Folder',
	children: [...files]
});

const SYSTEM = files => new File({
	name: 'System',
	type: 'System Folder',
	children: [...files]
});

const NETWORK = files => new File({
	name: 'Network',
	type: 'System Folder',
	icon: 'fa fa-sitemap',
	component: '/Programs/FileSystem/FileSystem',
	initProp: { path: '/Desktop/Network' , iconView: true },
	children: [...files]
});

const RECYCLE_BIN = files => new File({
	name: 'Recycle Bin',
	type: 'System Folder',
	icon: 'fa fa-trash-o',
	component: '/Programs/FileSystem/FileSystem',
	initProp: { path: '/Desktop/Recycle Bin' , iconView: true },
	children: [...files]
});

const FILE_SYSTEM = files => new File({
	name: 'File System',
	type: 'System File',
	icon: 'fa fa-database',
	component: '/Programs/FileSystem/FileSystem',
	initProp: { path: '/Desktop/My Computer/Drive' , treeView: true },
	windowData: {
		duplicable: true, // move to windowData
	}
});

//------------------------------------------------------------
// DIALOGS - SYSTEM FILES
//------------------------------------------------------------

const INFO = files => new File({
	name: 'Info',
	type: 'System File',
	icon: 'fa fa-user-o',
	component: '/Dialogs/Info',
	windowData: {
		width: 300,
		height: 400,
		duplicable: true,
		maximizable: false
	}
});

const MENU = files => new File({
	name: 'Menu',
	type: 'System File',
	icon: 'fa fa-user-o',
	component: '/Dialogs/Menu',
	windowData: {
		width: 300,
		height: 400,
		maximizable: false
	}
});

const USER = files => new File({
	name: 'User',
	type: 'System File',
	icon: 'fa fa-user-o',
	component: '/Dialogs/User',
	windowData: {
		width: 400,
		height: 500,
		maximizable: false
	}
});

const BROWSER = files => new File({
	name: 'Browser',
	type: 'Program',
	alias: '/Programs/etc',
	icon: 'fa fa-globe',
	component: '',
	initProp: { path: '/Desktop/My Computer/Drive' , treeView: true },
	windowData: {
		duplicable: true
	}
});

const ICU = files => new File({
	name: 'ICU Messenger',
	type: 'Program',
	alias: '/Programs/etc',
	icon: 'fa fa-comments',
	component: '/Programs/Messenger/Messenger',
	windowData: {
		minWidth: 270,
		width: 270,
		height: 600,
		maxWidth: 270,
		maximizable: false
	}
});

const FILE_CLUSTER = () => {
	let cluster = [];
	for (let i=0; i < 100; i++) {
		const file = new File({
						name: Math.random().toString(36).substr(2, 9) + i + '.sys',
						type: 'File',
						icon: 'fa fa-file-o',
						size: Math.ceil(Math.random() * 5-1) + 'KB',
						component: '/Dialogs/User',
						windowData: {
							width: 300,
							height: 600
						}
					});
		cluster.push(file);
	}

	return cluster;
}

//------------------------------------------------------------
// PLAYER FILE SYSTEM
//------------------------------------------------------------

const FS_PLAYER = new FileSystem(
	ROOT([
		DESKTOP([
			MY_COMPUTER([
				DRIVE([
					HOME([
						DOCUMENTS([]),
						PICTURES([])
					]),
					LOGS([...
					     FILE_CLUSTER()
					]),
					PROGRAMS([
						ACCESSORIES([])
					]),
					SYSTEM([
						INFO([]),
						MENU([]),
						USER([])
					])
				])
			]),
			NETWORK([]),
			RECYCLE_BIN([]),
			FILE_SYSTEM([]),
			ICU([]),
			BROWSER([])
		])
	])
);

// console.log(JSON.stringify(FS_PLAYER, null, 2))

//------------------------------------------------------------
// PC
//------------------------------------------------------------

const FS_PC = {
	system: 'example'
}

//------------------------------------------------------------
// SERVER
//------------------------------------------------------------

const FS_SERVER = {
	system: 'example'
}

//------------------------------------------------------------
// EXPORTS
//------------------------------------------------------------

export default {
	FS_PLAYER,
	FS_PC,
	FS_SERVER
}